import { render, staticRenderFns } from "./deal-dialog.vue?vue&type=template&id=2b6cb4c4&scoped=true&"
import script from "./deal-dialog.vue?vue&type=script&lang=js&"
export * from "./deal-dialog.vue?vue&type=script&lang=js&"
import style0 from "./deal-dialog.vue?vue&type=style&index=0&id=2b6cb4c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6cb4c4",
  null
  
)

export default component.exports